<script lang="ts" setup>
import Link8 from '@/components/Button/Link8.vue'
import Link11 from '@/components/Button/Link11.vue'
import type { PropType } from 'nuxt/dist/app/compat/capi';
const props = defineProps({
  data: Object as PropType<any>
})

const isOpen = ref(false)
</script>

<template>
  <div>
    <div class="card">
      <div class="card__title" v-if="props.data.title">{{ props.data.title }}</div>
      <div class="card__text" v-if="props.data.text">{{ props.data.text }}</div>
      <div v-if="props.data.content">
        <Link8 :linkTitle="isOpen ? '收合資訊' : '詳細資訊'" :icon="isOpen ? 'icon-minus' : 'icon-plus'" class="card__toggle"
          :class="{ isOpen }" @click="isOpen = !isOpen" />
        <div class="card__toggle__content" v-show="isOpen" v-html="props.data.content"></div>
      </div>
      <div class="card__link" :class="{ isOpen }" v-if="props.data.link">
        <Link11 linkTitle="詳細資訊" :to="props.data.link" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  padding: toRem(48);

  @include max-media(480) {
    padding: toRem(24);
  }

  &__title {
    margin-bottom: toRem(24);
    font-size: toRem(28);
    font-weight: 500;
    line-height: 1.3;
    color: $color-brand-3;

    @include max-media(480) {
      font-size: toRem(22);
    }
  }

  &__text {
    margin-bottom: toRem(24);
    font-size: toRem(16);
    font-weight: 400;
    line-height: 1.45;
  }

  &__toggle {
    cursor: pointer;
    margin-bottom: toRem(24);

    :deep(.link__icon) {
      color: $color-gray-1;
      width: toRem(16);
      height: toRem(16);
    }

    &.isOpen {}

    &__content {
      border-radius: toRem(6);
      background-color: $bg-1;
      padding: toRem(24);
      font-size: toRem(14);
      line-height: 1.4;
      color: $color-gray-1;
    }
  }

  &__link {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: toRem(90);

    &.isOpen {
      margin-top: toRem(24);
    }
  }
}
</style>
